module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.2751ee43.woff2";